<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __PaymentStatusLabel, {PaymentStatusLabel as _PaymentStatusLabel} from '~src/components/account/snippets/PaymentStatusLabel.vue'

    @Component({mixins: [__PaymentStatusLabel]})
    export class PaymentStatusLabel extends _PaymentStatusLabel {
        // UI-24 (Point E): hide the invoicing-status label (e.g. "Not Invoiced") for ZSH.
        // The core template wraps the label in `v-if="showPaymentAndInvoiceStatus"`; returning
        // false here stops it from rendering. Core behavior is unchanged for other builds.
        get showPaymentAndInvoiceStatus() {
            return false
        }
    }

    export default {...toNative(PaymentStatusLabel), ssrRender: __PaymentStatusLabel.ssrRender}
</script>
